(function paycheckFindControllerDefinition() {
    'use strict';

    angular.module('Paycheck')
        .controller('PaycheckFindController', [
            '$q', '$filter', '$scope', '$state', 'errorsExtend', 'processCustomerService', 'configViewService', '$translate', 'storageService', 'fileWorkflowService', 'fileDownloader', 'exportProcessService', 'authExtend',
            function paycheckFindController($q, $filter, $scope, $state, errors, processCustomerService, configViewService, $translate, storageService, fileWorkflowService, fileDownloader, exportProcessService, auth) {
                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: true
                };

                if ($state.params.isSignPending) {
                    $scope.legend = { type: 'warning', message: 'PayCheckSignPending' }
                }

                $scope.createFilters = function () {

                    var filters = {
                        name: $scope.find.name,
                        processTypeId: $scope.find.processType.id,
                        organizationalUnitId: $scope.find.organizationalUnitId,
                        processStatesIds: [],
                        metadatas: [],
                        dateFrom: $scope.find.dateFrom,
                        dateTo: $scope.find.dateTo,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage
                    };

                    $scope.find.showNoData = false;

                    $scope.find.processType.metadatas.forEach(function (meta) {
                        var metadata = meta;

                        if (meta.metadataType === 'period' && (meta.metadataValueFrom && !meta.metadataValueTo)) {
                            metadata = angular.copy(meta);
                            metadata.metadataSearchTypeFrom = 'Equal';
                        }

                        filters.metadatas.push(metadata);
                    });

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        $scope.find.selectedStates.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    } else {
                        $scope.find.processType.states.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    }

                    return filters;
                }

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();
                    $scope.loadActions();

                    filters.sortByField = 'mvs.fv._peri';

                    return processCustomerService.advancedGet(filters).then(function (result) {
                        $scope.paychecks = [];
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        result.values.forEach(function (value) {
                            var r = value;
                            r.metadatas = [];

                            $scope.find.processType.headers.forEach(function (header) {
                                var metadataFound = $filter('filter')(value.metadataValues, { systemName: header.systemName }, true);

                                if (metadataFound && metadataFound.length != 0) {
                                    var metadataDescription = metadataFound[0].value;
                                    filters.metadatas.forEach(function (value) {
                                        var metadataOptionFound = $filter('filter')(value.metadataOptions, { value: metadataFound[0].value }, true);
                                        if (metadataOptionFound && metadataOptionFound.length != 0) {
                                            metadataDescription = metadataOptionFound[0].description;
                                        }
                                    });
                                    r.metadatas.push({ value: metadataDescription, type: metadataFound[0].type, mask: header.mask });
                                } else {
                                    r.metadatas.push({ value: null, type: null, mask: null });
                                }
                            });

                            $scope.paychecks.push(r);
                        });

                        if ($scope.paychecks.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.paychecks.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.findAction = function () {
                    if (!$scope.paycheckFind.$valid) {
                        $scope.paycheckFind.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    storageService.setPaychecksFilter($scope.find);

                    $scope.executeFind();
                };

                $scope.view = function (payc) {
                    $state.go('paycheck-detail', { id: payc.id });
                };

                $scope.viewFromRow = function (event, payc) {
                    if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {

                        if (event.target.parentElement != null && event.target.parentElement.id === "paycheck") {
                            $scope.view(payc);
                        }
                    }
                };

                $scope.loadPreFilters = function () {
                    if (!$scope.find.processType) {
                        var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                        $scope.find.processType = angular.copy(found[0] || $scope.processTypes[0]);
                    }

                    $scope.find.selectedStates = $filter('filter')($scope.find.processType.states, { preSelected: true }, true);
                };

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;

                    storageService.clearPaychecksFilter();
                    $scope.find = storageService.getPaychecksFilter();

                    $scope.paychecks = [];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.loadPreFilters();

                    angular.forEach($scope.processTypes, function (item) {
                        if (item.id === $scope.find.processType.id) {
                            $scope.find.processType.metadatas = angular.copy(item.metadatas);
                        }
                    });
                };

                $scope.fillAccordion = function () {
                    $scope.paychecks.forEach(function (paycheck) {
                        var accordionIsOpen = false;
                        Object.defineProperty(paycheck, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {
                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {
                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {
                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.selectProcessType = function (processType) {
                    $scope.find.processType = angular.copy(processType);
                    $scope.paychecks = [];
                    $scope.find.showResult = false;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.loadPreFilters();
                };

                $scope.loadMetadata = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.searchCriteria) {
                            processType.metadatas.push({
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType.toLowerCase(),
                                metadataSystemName: metadata.systemName,
                                metadataLabel: metadata.searchCriteria.name,
                                metadataReadOnly: !metadata.searchCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.searchCriteria.order
                            });
                        }

                        if (metadata.resultCriteria) {
                            processType.headers.push({ label: metadata.resultCriteria.name, systemName: metadata.systemName, order: metadata.resultCriteria.order, mask: metadata.resultCriteria.mask });
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    })

                    processType.states.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.loadViewOptions = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if ($scope.processTypes && $scope.processTypes.length > 0) {
                        defered.resolve();
                    } else {
                        configViewService.getById("CPPPaycheck").then(function (result) {
                            if (result.processTypes && result.processTypes.length > 0) {
                                $scope.states = result.processTypes[0].groupStates;
                                $scope.processTypes = [];
                                angular.forEach(result.processTypes, function (item) {
                                    $scope.loadMetadata(item);
                                });
                            }

                            defered.resolve();
                        }, function (error) {
                            errors.showError(error);
                            defered.reject();
                        });
                    }

                    return promise;
                };

                $scope.isEditable = function (paycheck) {
                    var resul = false;
                    var states = $scope.states;
                    for (var i = 0; i < states.length; i++) {
                        if (states[i].ids[0].toString() === paycheck.stateId.toString()) {
                            resul = states[i].edit;
                        };
                    };
                    return resul;
                };

                $scope.downloadAllFiles = function () {
                    var filters = $scope.createFilters();
                    filters.itemPerPage = null;
                    filters.page = null;

                    return processCustomerService.advancedGet(filters).then(function (result) {
                        var files = [];
                        var paychecks = result.values;

                        paychecks.forEach(function (paycheck) {
                            if (paycheck.files.length > 0) {
                                var mvs = paycheck.metadataValues.map(function (mv) {
                                    switch (mv.systemName) {
                                        case '_nroleg':
                                        case '_peri':
                                        case '_trec':
                                            return mv.value;
                                    }
                                }).filter(function (mv) { return mv });

                                files.push({
                                    id: paycheck.files[0].id,
                                    name: (mvs.length == 3 ? mvs[2] + ' - ' : '') + mvs[0] + ' - ' + mvs[1] + ' - ' + paycheck.stateAlias + ' [' + paycheck.files[0].creationDate.replace(/:/g, '.') + '].pdf'
                                });
                            }
                        });

                        return fileWorkflowService.downloadFilesIntoZip(files).then(function (result) {

                            var success = fileDownloader.saveAs(result.value, $translate.instant('PaycheckAllFiles') + '.zip');

                            if (!success) {
                                errors.showError('Api failed');
                            }

                        }, function (error) {
                            if (error.status === 204) {
                                errors.showWarning('The document has no files');
                            } else {
                                errors.showError('Api failed');
                            }
                        });
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.downloadFile = function (paycheck) {
                    var file = paycheck.files[0];
                    var metadata = {
                        nrolegValue: '',
                        periValue: '',
                        trecValue: ''
                    };

                    for (var i = 0; i < paycheck.metadataValues.length; i++) {
                        switch (paycheck.metadataValues[i].systemName) {
                            case '_nroleg': metadata.nrolegValue = paycheck.metadataValues[i].value; break;
                            case '_peri': metadata.periValue = paycheck.metadataValues[i].value; break;
                            case '_trec': metadata.trecValue = paycheck.metadataValues[i].value; break;
                        }
                    }
                    return fileWorkflowService.downloadFile(file.id).then(function (result) {
                        var fileName = metadata.nrolegValue + ' - ' + metadata.periValue + ' - ' + metadata.trecValue + ' - ' + paycheck.stateAlias + ' [' + paycheck.files[0].creationDate.replace(/:/g, '.') + '].pdf';                    
                        var success = fileDownloader.saveAs(result, fileName);

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.exportToExcel = function () {
                    return $translate(['ProcessReceptionDateView', 'ProcessState', 'User', 'ProcessName'])
                        .then(function (translated) {
                            var headers = [];

                            var filters = $scope.createFilters();

                            filters.itemPerPage = null;
                            filters.page = null;

                            headers.push({ key: "CreationDate", value: "F. Recepcion" });

                            $scope.find.processType.headers.forEach(function (header) {
                                headers.push({ key: header.systemName, value: header.label });
                            });

                            headers.push({ key: "StateAlias", value: translated.ProcessState });
                            headers.push({ key: "UserStep", value: translated.User });
                            headers.push({ key: "Name", value: translated.ProcessName });

                            return exportProcessService.exportCustomerToXLS(filters, headers, 'Recibos').then(function (result) {
                                var d = new Date();

                                var docName = "Mis Recibos";

                                var success = fileDownloader.saveAs(result.value, docName +
                                    '_' +
                                    d.getUTCFullYear() +
                                    '-' +
                                    (d.getUTCMonth() + 1) +
                                    '-' +
                                    d.getDate() +
                                    '.xlsx');

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                errors.showError('Api failed');
                            });
                        });
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.paychecks.length > 0) {
                        $scope.paychecks.forEach(function (pc) {
                            pc.check = $scope.checkAll;
                        });
                    }
                };

                $scope.sign = function () {
                    var toSign = [];

                    $scope.paychecks.forEach(function (paycheck) {
                        if (paycheck.check) {
                            toSign.push(paycheck);
                        }
                    });

                    if (toSign.length == 0) {
                        errors.showWarning('SignNoProcess');
                    } else {
                        processCustomerService.setSignProcesses(toSign);
                        $state.go('paycheck-sign');
                    }
                };

                $scope.signAll = function () {
                    var toSign = [];

                    var filters = $scope.createFilters();
                    filters.itemPerPage = 0;
                    filters.page = 1;

                    return processCustomerService.advancedGet(filters).then(function (result) {
                        toSign = result.values;
                        if (toSign.length == 0) {
                            errors.showError('SignNoProcess');
                        } else {
                            processCustomerService.setSignProcesses(toSign);
                            $state.go('paycheck-sign');
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.loadActions = function () {
                    $scope.actions = {
                        edit: false
                    };

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        var bEdit = $scope.find.selectedStates.every(function (item) {
                            return item.edit;
                        });

                        $scope.actions = {
                            edit: bEdit,
                            editName: 'PaycheckRRHH' + $scope.find.selectedStates[0].editName,
                            editNameAll: 'PaycheckRRHH' + $scope.find.selectedStates[0].editName + 'All'
                        };
                    }
                };

                $scope.edit = function (paycheck) {
                    $state.go('paycheck-edit', { id: paycheck.id });
                };

                $scope.load = function () {
                    $scope.checkAll = false;
                    $scope.userId = auth.getUserId();
                    $scope.signPermission = auth.isInRole('PAYCHECKCUSTOMER SIGN');
                    //$scope.signAllPermission = auth.isInRole('PAYCHECK MULTIPLE SIGN');
                    $scope.signAllPermission = auth.isInRole('PAYCHECKCUSTOMER SIGN');

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.find = storageService.getPaychecksFilter();

                    $q.all([$scope.loadViewOptions()]).then(function (result) {
                        $scope.loadPreFilters();
                        $scope.executeFind();
                    });
                };

                $scope.load();

            }]);
})();